import React, { FC } from "react";
import { Button, Dimmer, Icon, Loader, Modal, ModalProps } from "semantic-ui-react";
import {envColor} from '../common';

interface Props extends ModalProps {
    onClose: () => void;
    saveFile: (url: string) => void;
    showFile: (url: string, index: number) => void;
    fileInfo: { url: string; index: number };
    loading: boolean;
}

const FileSizeExceedsLimitWindow: FC<Props> = (props) => {
    const { onClose, saveFile, loading, showFile, fileInfo, ...modalProps } = props;

    const onSaveButton = () => {
        saveFile(fileInfo.url);
        onClose();
    };

    return (
        <Modal size="mini" open={true} {...modalProps} onClose={onClose}>
            <Modal.Content scrolling>
                {loading ? (
                    <Dimmer inverted active={true}>
                        <Loader />
                    </Dimmer>
                ) : (
                    <Modal.Description>
                        The file could not be displayed because it is larger than 1 MB
                    </Modal.Description>
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button circular icon labelPosition="left" color={envColor} onClick={() => onSaveButton()}>
                    <Icon name="save" />
                    Save
                </Button>
                <Button circular icon labelPosition="left" onClick={() => showFile(fileInfo.url, fileInfo.index)}>
                    <Icon name="eye" />
                    Show it anyway
                </Button>
                <Button circular onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default FileSizeExceedsLimitWindow;
